export default "__VITE_ASSET__DJliYGpG__"